<template>
  <div class="page container">
    <Menu></Menu>
    <h1 class="title is-4  ">
      <small class="has-text-weight-bold">Preços</small>
    </h1>
    <div class="subtitle is-6">
      Criação dos preços que o usuário poderá se inscrever.
    </div>
    <div v-if='plans.length == 0 ' style="padding: 20px 0px;">
      <i>Não existem preços cadastrados</i>
    </div>
    <table class="table is-fullwidth" v-else>
      <thead>
      </thead>
      <tbody>
        <template v-for='(c,i) in plans'>
          <tr v-bind:key='`${c.uuid}-1`' class="conteudo-aula-title">
            <td>
              <div class="section-title" >
                <b>Preço {{i+1}}:</b><span style="margin-left:10px; margin-right:10px;">{{c.titulo}}</span> <b style="color:#444; margin-right: 10px;"> R$ {{valorize(c.valor)}}</b>
                <el-button-group class="btns-class-title-section">
                  <el-button type="default" size="small" :type="c._viewOption?'primary':'default'" @click='toggleDetails(c)'><i class="fas fa-pencil-alt" ></i></el-button>
                  <el-button type="danger" size="small" @click='removePlan(c)'><i class="fas fa-trash"></i></el-button>
                </el-button-group>
              </div>
            </td>
            <td  style="width: 110px;">
              <div class="td-view" >
              </div>
            </td>
            <td  style="width: 110px;">
              <div class="td-view" >
                
                <span style="margin-right:10px;">5</span>
                <i class="fas fa-user"></i>
              </div>
            </td>
            <td  style="width: 100px;padding:10px;">
              <el-button-group>
                <el-button :type="c._viewOption?'primary':'default'" size="default" @click='toggleDetails(c)'>
                  <i class="fa fa-pencil-alt"></i>
                </el-button>
              </el-button-group>
            </td>
          </tr>
          <tr v-bind:key='`${c.uuid}-2`'>
            <td class="conteudo-aula" colspan="4" v-if='c._viewOption == "details"' style="padding-top:30px;">
              
              <el-form ref="form" :model="c" label-width="180px">
                <el-form-item label="Título">
                   <el-input v-model="c.titulo"></el-input>
                </el-form-item>
                <el-form-item label="Valor">
                  <money  v-model="c.valor" v-bind="money"></money>
                </el-form-item>
                <el-form-item label="Descrição do Plano">
                  <vue-editor v-model="c.descricao" placeholder='Adicione uma descrição a sua aula.'></vue-editor>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="salvarPlano(c)">Salvar</el-button>
                  <el-button @click='toggleDetails(c)'>Cancelar</el-button>
                </el-form-item>
              </el-form>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
      
    <!--<form action="https://desenvolvedor.moip.com.br/sandbox/PagamentoMoIP.do" method="post">
      <input type="hidden" name="id_carteira" value="integracao@labs.moip.com.br">
      Produto: <input type="text" name="nome" value="Motivo do pagamento"><br />  
      Valor: <input type="text" name="valor" value="100"><br />
      <input type="hidden" name="id_transacao" value="">    
      <input type="hidden" name="descricao" value="Adicione aqui mais informações sobre o pagamento">
      <input type="hidden" name="frete" value="1">  
      Peso Frete: <input type="text" name="peso_compra" value="1000"><br />   
      Nome completo: <input type="text" name="pagador_nome" value="Nome Sobrenome"><br /> 
      Email: <input type="text" name="pagador_email" value="email@comprador.com.br"><br />    
      Telefone: <input type="text" name="pagador_telefone" value="1155555555"><br />  
      Rua: <input type="text" name="pagador_logradouro" value="Rua do pagador"><br /> 
      Numero: <input type="text" name="pagador_numero" value="123"><br /> 
      Complemento: <input type="text" name="pagador_complemento" value="ap 001"><br />
      Bairro: <input type="text" name="pagador_bairro" value="Bairro do pagador"><br />
      CEP: <input type="text" name="pagador_cep" value="11111111"><br />  
      Cidade: <input type="text" name="pagador_cidade" value="São Paulo"><br />
      Estado: <input type="text" name="pagador_estado" value="SP"><br />  
      <input type="hidden" name="pagador_pais" value="Brasil">  
      CPF: <input type="text" name="pagador_cpf" value="22222222222"><br />   
      <input type="hidden" name="url_retorno" value="https://sualoja.com.br/notificacao/">
      <input type='image' name='submit' src='https://desenvolvedor.moip.com.br/sandbox/imgs/buttons/bt_pagar_c02_e04.png' alt='Pagar via Moip' border='0' />-->
  </form>
    <el-button-group>
      <el-button type="primary" size="small" @click='addPlan'><i class="fas fa-plus" ></i> Novo Plano</el-button>
    </el-button-group>
  </div>  
</template>

<script>
  import Menu from './_menu';
  import uuid from 'uuid/v4';
  import {Money} from 'v-money';
  import { VueEditor } from 'vue2-editor'
  import * as R from 'ramda';
  import axios from 'axios';

  export default {
    components: {
      Menu,
      Money,
      VueEditor
    },
    data() {
      return {
        plans: [ ],
        price: 123.45,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        }
      }
    },
    methods: {
      addPlan() {
        const num = this.plans.length;
        this.plans.push(
          { id: '*', 
            uuid: uuid(), 
            title: 'Sem título',
            description: '',
            price: 0.00,
            recorrente: true,
            garantia: 0,
            _viewOption: null
          }
        )
      },
      valorize(v){
        return parseFloat(v).toFixed(2)
      },
      removePlan(c) {
        const idx = R.findIndex(R.propEq('uuid', c.uuid))(this.plans);
        if(idx >= 0)
          this.plans.splice(idx, 1);
      },
      onSubmit() {
        console.log('submit!');
      },
      toggleDetails(c) {
        if(c._viewOption){
          c._viewOption = '';
        }else{
          c._viewOption = 'details';
        }
      },
      getPlanos(){
        const curso_id = this.$route.params.curso;
        global.Loading.begin(`Carregando planos #${curso_id}`);
        axios.get(`${global.base}/api/admin/curso/${curso_id}/planos/`,{
          headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
          }).then((r)=>{
            global.Loading.end();
            this.plans = r.data.map(p => {
              return {...p, _viewOption: null}
            });
          }).catch(()=>{
            global.Loading.end();
          })
      },
      salvarPlano(p){
        const curso_id = this.$route.params.curso;
        global.Loading.begin(`Salvando plano #${p.titulo}`);
        axios({
            method: 'post',
            url: `${global.base}/api/admin/curso/${curso_id}/plano`,
            data: {
              dados: {
                id: p.id,
                uuid: p.uuid,
                curso_id: curso_id,
                titulo: p.titulo,
                valor: p.valor,
                descricao: p.descricao,
              }
            },
            headers: { 'authorization': `bearer ${this.$store.state.session.jwt}` },
            }).then((r)=>{
              p.id = r.data.id;
            global.Loading.end();
          }).catch(()=>{
            global.Loading.end();
          })
      }
    },
    mounted(){
      this.getPlanos();
    }
  };
</script>

<style scope>
 .v-money{
  padding: 0px 10px;
 }

</style>